import type { ColDef, ICellRendererParams } from "ag-grid-enterprise";
import { Box, IconButton, Tooltip } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import type { RollApplication } from "../models/RollApplication";
import { activeColumnDef } from "@/controls/ag-grid/components/ActiveColumn";

interface UseTableDataProps {
	onDelete: (app: RollApplication) => void;
}

export const useTableData = ({ onDelete }: UseTableDataProps) => {
	const columnDefs: ColDef<RollApplication>[] = [
		{
			field: "Name",
			headerName: "Name",
			flex: 2,
			sortable: true,
			filter: true,
		},
		{
			field: "RollMaterialName",
			headerName: "Roll Material",
			flex: 1.5,
			sortable: true,
			filter: true,
		},
		{
			field: "MaximumHardness",
			headerName: "Max Hardness",
			flex: 1,
			valueFormatter: (params: { value: number | null }) =>
				params.value != null ? params.value.toFixed(0) : "",
		},
		{
			field: "MinimumHardness",
			headerName: "Min Hardness",
			flex: 1,
			valueFormatter: (params: { value: number | null }) =>
				params.value != null ? params.value.toFixed(0) : "",
		},
		activeColumnDef<RollApplication>(),
		{
			headerName: "",
			width: 60,
			minWidth: 60,
			maxWidth: 60,
			sortable: false,
			filter: false,
			resizable: false,
			suppressSizeToFit: true,
			cellRenderer: (params: ICellRendererParams<RollApplication>) => {
				if (!params.data) return null;
				return (
					<Box
						sx={{
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
							height: "100%",
						}}
					>
						<Tooltip title="Delete">
							<IconButton
								size="small"
								onClick={(e) => {
									e.stopPropagation();
									onDelete(params.data as RollApplication);
								}}
								color="error"
								sx={{ p: 0.25 }}
							>
								<DeleteIcon fontSize="small" />
							</IconButton>
						</Tooltip>
					</Box>
				);
			},
		},
	];

	return { columnDefs };
};
